import {register} from '../vendor/theme-scripts/theme-sections';
import parallaxImage from '../features/image-parallax';

register('blog', parallaxImage);
